import { createFileRoute } from "@tanstack/react-router";
import AdminBuilderDetail from "lib/components/admin/builders/AdminBuilderDetail";
import AdminBuilderList from "lib/components/admin/builders/AdminBuilderList";
import AdminPage from "lib/components/admin/builders/AdminPage";
import SplitView from "lib/components/layout/SplitView";
import withAuthentication from "../../components/withAuthentication";

function AdminBuildersPage() {
  return (
    <AdminPage currentPage="builders" pageTitle="Admin - Builders">
      <SplitView left={<AdminBuilderList />} right={<AdminBuilderDetail />} />
    </AdminPage>
  );
}

export const Route = createFileRoute("/admin/builders")({
  component: withAuthentication(AdminBuildersPage, { superAdmin: true }),
});
